import { CloseCircleOutlined, WarningFilled } from '@ant-design/icons';
import { Modal } from 'antd';
import { ErrorDto } from '../../../core/models/dtos/error.dto';
import { setApiError } from '../../../core/services/app/setApiError/setApiError.slice';
import { Errors } from '../../../core/services/errors';
import { useAppDispatch, useAppSelector } from '../../../core/services/hooks';
import { UI } from '../../../core/utilities/ui';
import AppButton from '../../Buttons/AppButton/AppButton';
import React, { useEffect, useState } from 'react';
import './ApiErrorModal.scss';

function ApiErrorModal() {
  const apiError = useAppSelector((state) => state.app.setApiError.error);
  const dispatch = useAppDispatch();
  const [errorMessage, setErrorMessage] = useState<string>(Errors.errorGenericText);

  const isOpen = (): boolean => {
    return !!apiError;
  };

  const closeModal = (): void => {
    dispatch(setApiError());
  };

  const isMilesError = (): boolean => {
    return apiError?.source === 'MILES';
  };

  const getText = async (error: ErrorDto): Promise<string> => {
    if (error instanceof Blob) {
      try {
        const text = await error.text();
        const jsonError = JSON.parse(text);
        return jsonError.message ?? Errors.errorGenericText;
      } catch (parseError) {
        console.error("Hata mesajı çözülemedi:", parseError);
        return Errors.errorGenericText;
      }
    }
    return error.message ?? Errors.errorGenericText;
  };

  useEffect(() => {
    if (apiError) {
      getText(apiError).then((message) => setErrorMessage(message));
    }
  }, [apiError]);

  return (
    <Modal
      className="api-error-modal"
      maskStyle={UI.modalMaskStyle()}
      open={isOpen()}
      closable={false}
      footer={null}
      centered
      destroyOnClose
      onCancel={closeModal}
    >
      {apiError && (
        <div className="content">
          {isMilesError() ? (
            <div className="warning-icon-wrapper">
              <WarningFilled className="warning-icon" />
            </div>
          ) : (
            <CloseCircleOutlined className="icon" />
          )}
          {isMilesError() && apiError.title && (
            <span className="title">{apiError.title}</span>
          )}
          <span className="text">{errorMessage}</span>
          <AppButton onClick={closeModal}>OK</AppButton>
        </div>
      )}
    </Modal>
  );
}

export default ApiErrorModal;
